module.exports = __webpack_public_path__ + "img/stock0.b0605fa4.png";